import { Content, Portal, Root, Trigger } from '@radix-ui/react-popover'
import { useState } from 'react'

import { type FloatingPopoverType } from '@/defs/floating'

import { FloatingArrow } from '../../common/FloatingArrow/FloatingArrow'
import { getFloatingContentProps } from '../../common/getFloatingContentProps'
import { FloatingBox } from '../../FloatingBox/FloatingBox'
import { FloatingProvider } from '../../FloatingProvider/FloatingProvider'

export const FloatingPopoverDesktop = (props: FloatingPopoverType) => {
  const { autoOpen, children, ignoreScopes, onInteractOutside, placement, ...rest } = props
  const [isOpen, setIsOpen] = useState(!!autoOpen)
  const [prevAutoOpen, setPrevAutoOpen] = useState(!!autoOpen)

  if (!!autoOpen !== prevAutoOpen) {
    setPrevAutoOpen(!!autoOpen)
    if (autoOpen) setIsOpen(true)
  }

  return (
    <Root onOpenChange={setIsOpen} open={isOpen}>
      <Trigger asChild>{children}</Trigger>
      <Portal>
        <Content
          {...getFloatingContentProps({ ignoreScopes, placement })}
          onCloseAutoFocus={(e) => e.preventDefault()}
          onInteractOutside={onInteractOutside}
        >
          <FloatingProvider setIsOpen={setIsOpen}>
            <FloatingArrow type='popover' />
            <FloatingBox {...rest} />
          </FloatingProvider>
        </Content>
      </Portal>
    </Root>
  )
}
